/**
 * Kundenportal Api
 * Kundenportal Api
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountMovement { 
    buchungsDat: string;
    belegnummer: string;
    status: AccountMovement.StatusEnum;
    textVorgang: string;
    textBuchung: string;
    soll: number;
    haben: number;
    nochOffen: number;
    sollFw: number;
    habenFw: number;
    nochOffenFw: number;
    fremdwaehrung: string;
    fallig: string;
    abrZeitVon: string;
    abrZeitBis: string;
}
export namespace AccountMovement {
    export type StatusEnum = 'Forderung offen und fällig' | 'Forderung offen, noch nicht fällig' | 'Zahlungsauftrag erstellt - noch offen' | 'Forderung bezahlt' | 'Storniert' | '';
    export const StatusEnum = {
        FORDERUNG_OFFEN_UND_FLLIG: 'Forderung offen und fällig' as StatusEnum,
        FORDERUNG_OFFEN_NOCH_NICHT_FLLIG: 'Forderung offen, noch nicht fällig' as StatusEnum,
        ZAHLUNGSAUFTRAG_ERSTELLT___NOCH_OFFEN: 'Zahlungsauftrag erstellt - noch offen' as StatusEnum,
        FORDERUNG_BEZAHLT: 'Forderung bezahlt' as StatusEnum,
        STORNIERT: 'Storniert' as StatusEnum,
        EMPTY: '' as StatusEnum
    };
}


